import {BorderArticle} from "@/components/ui/general/BorderArticle";

import React from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

const REF_NS = "page.effectiveness.references";

export const Libs = () => {
  const {t} = useTranslation();

  const industryItems = t(`${REF_NS}.industry_items`, {returnObjects: true});
  const trainingItems = t(`${REF_NS}.training_items`, {returnObjects: true});
  const compensationSources = t(`${REF_NS}.compensation_sources`, {
    returnObjects: true,
  });

  return (
    <BorderArticle>
      <div className={styles.effectiveness_libs}>
        <h6>{t(`${REF_NS}.title`)}</h6>

        <RootDesc>
          <span className={"text-[16rem]"}>{t(`${REF_NS}.intro`)}</span>
        </RootDesc>

        <RootDesc>
          <b>{t(`${REF_NS}.industry_title`)}</b>

          <ul>
            {Array.isArray(industryItems) &&
              industryItems.map((item, idx) => (
                <li key={idx}>
                  <span>
                    {item.lead}{" "}
                    <a
                      href={item.url}
                      target={"_blank"}
                      rel={"noopener noreferrer"}
                    >
                      {item.url}.
                    </a>
                  </span>
                </li>
              ))}
          </ul>

          <b className={"mt-[12rem] block"}>{t(`${REF_NS}.training_title`)}</b>

          <ul>
            {Array.isArray(trainingItems) &&
              trainingItems.map((item, idx) => (
                <li key={idx}>
                  <span>
                    {item.lead}{" "}
                    <a
                      href={item.url}
                      target={"_blank"}
                      rel={"noopener noreferrer"}
                    >
                      {item.url}.
                    </a>
                  </span>
                </li>
              ))}
          </ul>

          <b className={"mt-[12rem] block"}>
            {t(`${REF_NS}.compensation_title`)}
          </b>

          <b className={"mt-[8rem] block !font-[400]"}>
            {t(`${REF_NS}.compensation_intro`)}
          </b>

          <ul>
            {Array.isArray(compensationSources) &&
              compensationSources.map((line, idx) => (
                <li key={idx}>{line}</li>
              ))}
          </ul>
        </RootDesc>
      </div>
    </BorderArticle>
  );
};
